var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Dashboard > STYLIST NAME > Manage CLients > Add Clients")]),_vm._v("\n  Add Clients\n")])}]

export { render, staticRenderFns }